export function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  as: Component = 'button',
  ...props
}) {
  const baseStyles = 'font-semibold transition-all duration-200 rounded-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600 dark:focus-visible:ring-blue-400 dark:focus-visible:ring-offset-slate-900';

  const variants = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm',
    brand: 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-sm dark:focus-visible:ring-indigo-400 focus-visible:ring-indigo-600',
    secondary: 'bg-gray-100 hover:bg-gray-200 text-gray-900 dark:bg-slate-700 dark:hover:bg-slate-600 dark:text-white',
    danger: 'bg-red-600 hover:bg-red-700 text-white shadow-sm',
    success: 'bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white shadow-lg hover:shadow-xl',
    outline: 'border-2 border-blue-600 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:border-blue-400 dark:hover:bg-slate-700/50',
    ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 dark:text-slate-200 dark:hover:bg-slate-700',
  };

  const sizes = {
    sm: 'min-h-[44px] min-w-[44px] px-3 py-2 text-sm',
    md: 'min-h-[44px] min-w-[44px] px-5 py-2.5 text-sm',
    lg: 'min-h-[44px] min-w-[44px] px-7 py-3 text-base',
  };

  const isNativeButton = Component === 'button';

  return (
    <Component
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...(isNativeButton ? { disabled: disabled || loading } : {})}
      {...props}
    >
      {loading && <span className="animate-spin">⏳</span>}
      {children}
    </Component>
  );
}
